import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { CanComponentDeactivate } from '../../helpers/guards/unsaved-changes.guard';
import { ProjectDetails } from '../../data/models/project-details';
import { ProjectConfigurationService } from '../../data/project/project-configuration.service';
import { ProjectsApiService } from '../../api/projects-api.service';
import { ProjectService } from '../../data/project/project.service';
import { CancelConfirmationDialogComponent } from '../../components/dialogs/cancel-confirmation-dialog/cancel-confirmation-dialog.component';
import { CommonMessages } from '../../constants/common-messages';
import { StringConstants } from '../../constants/string-constants';

@Component({
    selector: 'app-project-configuration',
    templateUrl: './project-configuration.component.html',
    styleUrls: ['./project-configuration.component.scss'],
    standalone: false
})
export class ProjectConfigurationComponent implements CanComponentDeactivate, OnInit {
  project: ProjectDetails;
  projectDescription =
    'All sections must be completed before the project can proceed';
  //update the type of projectId later
  projectId: any;
  stylesObj = { color: 'var(--cobalt-blue)' };
  currentStep = 0;
  isSummary = false;
  dataLoaded = false;
  steps = [
    {
      step: 1,
      title: 'Solution Offerings',
      formGroupControlName: 'solutionOffering',
    },
    {
      step: 2,
      title: 'Scenarios',
      formGroupControlName: 'scenarios',
    },
    {
      step: 3,
      title: 'Modules',
      formGroupControlName: 'modules',
    },
    {
      step: 4,
      title: 'Users',
      formGroupControlName: 'users',
    },
    {
      step: 5,
      title: 'Questionnaire',
      formGroupControlName: 'questionnaire',
    },
  ];

  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private router: Router,
    public pcDataService: ProjectConfigurationService,
    private projectService: ProjectsApiService,
    private projectDataService: ProjectService
  ) {
    this.projectId = this.route.snapshot.paramMap.get('id');
    this.pcDataService.projectScenarioConfigurationData = this.route.snapshot.data;
  }

  async ngOnInit(): Promise<void> {
    this.project = await this.projectService.getProjectById(this.projectId);
    this.projectDataService.projectId = this.projectId;
    this.projectService.getProjectUsers(this.projectId).subscribe((projectUser: any) => {
      if (projectUser.length == 1) {
        this.projectDataService.initialAdminEmailId = projectUser[0].email;
      }
      this.dataLoaded = true;
    });
  }

  confirmExit(): void {
    this.router.navigateByUrl('/dashboard');
    //setting default solutionoffering to sell side
    this.pcDataService.defaultSolutionOffering = 1;
  }

  nextStepTitle(): string {
    if (this.currentStep + 1 in this.steps) {
      return `Add ${this.steps[this.currentStep + 1].title}`;
    } else {
      return 'Summary';
    }
  }

  hasPreviousStep(): boolean {
    return this.currentStep - 1 in this.steps;
  }

  goToStep(step: number): void {
    if (step in this.steps) {
      this.currentStep = step;
    } else if (step === 5) {
      // Navigate to summary page
      this.isSummary = true;
      this.router.navigateByUrl(`project-configuration/summary/${this.project.projectId}`);
    }
  }

  canDeactivate(): boolean | Observable<boolean> {
    if (this.currentStep == 4 && this.pcDataService.projectConfigurationFormGroup.valid && this.isSummary) {
      return true;
    }

    const dialogRef = this.dialog.open(CancelConfirmationDialogComponent, {
      disableClose: true,
      width: '45%',
      data: {
        title: CommonMessages.EXIT_PROJECT_CONFIGURATION_TITLE,
        description: '',
        confirmButtonText: CommonMessages.BUTTON_TEXT_YES,
        continueButtonText: CommonMessages.BUTTON_TEXT_CANCEL,
        action: StringConstants.CONFIGURATION,
      },
    });
    return dialogRef.afterClosed();
  }
}
